export default {
  row: { display: 'flex', justifyContent: 'space-between', gap: 2 },
};
